var _style, _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgAwsElb(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    viewBox: "0 0 120 120",
    style: {
      enableBackground: "new 0 0 120 120"
    },
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\n\t.st0{fill:none;}\n\t.st1{fill:#A94C17;}\n\t.st2{fill:#EF7C23;}\n\t.st3{fill:#FFFFFF;}\n")), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("rect", {
    y: 0.2,
    className: "st0",
    width: 119.7,
    height: 119.7
  }), /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("circle", {
    className: "st1",
    cx: 60,
    cy: 62.3,
    r: 57.5
  }), /*#__PURE__*/React.createElement("circle", {
    className: "st2",
    cx: 60,
    cy: 57.7,
    r: 57.5
  }), /*#__PURE__*/React.createElement("polygon", {
    className: "st3",
    points: "98,38.5 98,19.4 78.8,19.4 78.8,26.9 65.5,30.1 67.8,33.9 34.9,55 34.9,42.4 13.7,42.4 13.7,74.2  34.9,74.2 34.9,61.6 67.8,83 65.5,86.4 78.8,89.3 78.8,97.2 98,97.2 98,78 78.8,78 78.8,81.6 73,74.2 70.8,78.3 43.9,61.5  66.3,61.3 66.2,65.6 78.8,60.9 78.8,67.9 98,67.9 98,48.7 78.8,48.7 78.8,55.7 66.2,50.9 66.3,55 44.2,55 70.4,38.3 73,42.4  78.8,35 78.8,38.5  "
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAwsElb);
export default __webpack_public_path__ + "static/media/aws-elb.81570e2cf80ca3cdc1b3971e217bc17b.svg";
export { ForwardRef as ReactComponent };